<template>
  <div class="bedrooms-filter">
    <form-counter
      :id="0"
      class="counter"
      :label="`Bedrooms <span style='white-space:nowrap;'>(1 - ${maxAllowableBeds})</span>`"
      :min="0"
      :max="maxAllowableBeds"
      :set-value="getBedrooms"
      showAll
      showPlus
      @value="onCounterClicked"
    />
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import Bus from '../../../events/bus';
import cfg from '../../../config/config';
import responsive from '../../../mixins/responsive';
import FormCounter from '../../../components/FormCounter.vue';

const srcdata = {
  bedrooms: 0,
};

export default {
  name: 'Bedrooms',
  components: {
    FormCounter,
  },
  mixins: [responsive],
  props: {
    id: { type: Number, default: 4 },
  },
  data: () => srcdata,
  computed: {
    currentCollectionList() {
      return this.$store.getters['pages/getCollectionData'];
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 5 : false;
    },
    maxAllowableBeds() {
      return this.$store.getters['results/maxAllowableBeds']
    },
    getBedrooms() {
      return this.bedrooms;
    },
    rooms: {
      get() {
        return this.$store.getters['results/getBedrooms'];
      },
      set(value) {
        this.$store.commit('results/setBedrooms', value);
      },
    },
  },
  mounted() {
    Bus.$on('restoreFilterFromStore', this.restoreFilterFromStore);
    Bus.$on('restoreFilterFromURL', this.restoreFilterFromURL);
    Bus.$on('restoreFilterFromCookies', this.restoreFilterFromCookies);
    Bus.$on('resetBedrooms', this.reset);
    Bus.$on('resetOccupancy', this.reset);
    Bus.$on('selectBedroomsFilter', this.selectBedrooms);
    Bus.$emit('filterMounted', 'bedrooms');
    if (!this.isResultsPage) {
      this.restoreFilterFromCookies();
    }
    this.$store.dispatch('results/fetchMaxAllowableBeds');
  },
  beforeDestroy() {
    Bus.$off('restoreFilterFromStore', this.restoreFilterFromStore);
    Bus.$off('restoreFilterFromURL', this.restoreFilterFromURL);
    Bus.$off('restoreFilterFromCookies', this.restoreFilterFromCookies);
    Bus.$off('resetBedrooms', this.reset);
    Bus.$off('resetOccupancy', this.reset);
    Bus.$off('selectBedroomsFilter', this.selectBedrooms);
  },
  methods: {
    restoreFilterFromStore() {
      this.bedrooms = this.rooms;
      this.filterProperties(true);
    },
    restoreFilterFromURL() {
      this.resetValues();
      if (this.$route.query.rooms && this.$route.query.rooms > 0) {
        this.bedrooms = Number(this.$route.query.rooms);
        this.selectBedrooms(this.bedrooms, true);
      }
    },
    restoreFilterFromCookies() {
      if (!this.currentCollectionList && window.$cookies.get('bedrooms')) {
        this.bedrooms = window.$cookies.get('bedrooms');
        this.selectBedrooms(this.bedrooms, true);
      }
    },
    selectBedrooms(rooms, isRestore = false) {
      this.bedrooms = rooms;
      this.$store.commit('results/setBedrooms', rooms);
      if (!this.currentCollectionList) {
        window.$cookies.set('bedrooms', this.bedrooms, cfg.neverExpire);
      }
      this.filterProperties(isRestore);
    },
    onCounterClicked(value) {
      this.bedrooms = Number(value);
      this.$store.commit('results/setBedrooms', Number(value));
      if (!this.currentCollectionList) {
        window.$cookies.set('bedrooms', this.bedrooms, cfg.neverExpire);
      }
      this.isResultsPage ? this.debounceFilterProperties(false) : null;
    },
    debounceFilterProperties: _.debounce(function (isRestore) {
      this.filterProperties(isRestore);
    }, 600),
    filterProperties(isRestore) {
      if (this.isResultsPage) {
        this.$router.replace({ query: { ...this.$route.query, rooms: this.bedrooms && this.bedrooms > 0 ? this.bedrooms : undefined } });
        if (!isRestore) {
          Bus.$emit('filterProperties', 'occupancy - select beds');
        }
      }
    },
    reset(isRestore) {
      this.resetValues();
      this.$router.replace({ query: { ...this.$route.query, rooms: undefined } });
      !isRestore ? Bus.$emit('filterProperties', 'clear Bedrooms') : null;
    },
    resetValues() {
      this.bedrooms = 0;
      window.$cookies.set('bedrooms', '');
      this.$store.commit('results/setBedrooms', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.counter{
    margin: 20px 5px 20px 5px;
}

</style>
